import { render } from "./Book.vue?vue&type=template&id=829ddb4a&scoped=true&ts=true"
import script from "./Book.vue?vue&type=script&lang=ts"
export * from "./Book.vue?vue&type=script&lang=ts"

import "./Book.vue?vue&type=style&index=0&id=829ddb4a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-829ddb4a"]])

export default __exports__